import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import { extractImageFromZip } from "../../../utils/imageHandler";
//import slug from 'slug'

import Tag from "../../tag";

import styles from "./question-summary.module.css";
import { formatDistanceToNowStrict } from "date-fns";

function getslug(title) {
  return title
    .toLowerCase()
    .replace(/\s(-)\s/g, "-")
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}

const QuestionSummary = ({
  slug,
  title,
  tags,
  author,
  createdTime,
  children,
  feature_img
}) => {
  const [profilePhoto, setProfilePhoto] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      if (!author?.profilePhoto) {
        setProfilePhoto(null);
        return;
      }
      try {
        const extractedProfilePhoto = await extractImageFromZip(
          author.profilePhoto
        );
        setProfilePhoto(extractedProfilePhoto);
      } catch (e) {
        setProfilePhoto(null);
      }
    };
    fetchUser();
  }, [author]);

  const username = author?.username ?? "";
  const safeTags = Array.isArray(tags) ? tags : [];
  const created = createdTime ? new Date(createdTime) : null;
  return (
    <div className={styles.container}>
      {/* The STORED slug is the only key /question/:slug resolves. Rebuilding
          it from the title diverged for every auto-FAQ (Prigmar slugs strip
          punctuation differently and cap at 80 chars) and opened "Question
          not found." for 139 questions. */}
      <Link
        to={`/learning/questions/${slug || getslug(title || "")}`}
        className={styles.title}
      >
        {title}
      </Link>
      {feature_img && <img src={feature_img} />}

      <div className={styles.excerpt}>{children}</div>
      <div className={styles.footer}>
        <div className={styles.tagContainer}>
          {safeTags.map((tag) => (
            <Tag key={tag}>{tag}</Tag>
          ))}
        </div>
        <div className={styles.userDetails}>
          <Link to={`/learning/users/${username}`}>
            <img src={profilePhoto} alt={username} />
          </Link>
          <div className={styles.info}>
            <span>
              {created && !isNaN(created.getTime())
                ? `asked ${formatDistanceToNowStrict(created, { addSuffix: true })}`
                : "asked"}
            </span>
            <Link to={`/learning/users/${username}`}>
              {author?.name} {author?.lastName}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionSummary;
